/**
 * InvestnowCombined has been added with site id 28. IN KiwiSaver was given site
 * id 4 in the array below which in our database corresponds to IN retail.
 * I dont think this will cause any problems for now but may need to be
 * tidied up at some point. Once KiwiSaver and Retail have been combined, we can
 * deprecate 4 and 10 (The actual InvestNow KiwiSaver site ID)
 */

export enum SiteIds {
    INVESTNOW = "4",
    MYADMINIS = "5",
    KERNEL = "6",
    UBT = "7",
    INVESTNOWCOMBINED = "28",
    EVIDENTIAL = "18",
}
